import {
	LoginPage,
	ProjectCheckPage,
	ProjectCreatePage,
	ProjectDetailPage,
	ProjectsPage,
	SettingsPage,
	UserDetailPage,
	UsersPage,
	WebCheckDetailPage,
	WebChecksPage,
	WelcomePage,
} from './pages';
import {
	CHECK_PROJECT_ROUTE,
	CREATE_PROJECT_ROUTE,
	LOGIN_ROUTE,
	PROJECTS_ROUTE,
	PROJECT_DETAIL_ROUTE,
	SETTINGS_ROUTE,
	USERS_ROUTE,
	USER_DETAIL_ROUTE,
	WEB_CHECKS_ROUTE,
	WEB_CHECK_DETAIL_ROUTE,
	WELCOME_PAGE_ROUTE,
} from './utils/consts';

export const publicRoutes = [
	{
		path: LOGIN_ROUTE,
		Component: LoginPage,
	},
];

export const authRoutes = [
	{
		path: WELCOME_PAGE_ROUTE,
		Component: WelcomePage,
	},
	{
		path: PROJECTS_ROUTE,
		Component: ProjectsPage,
	},
	{
		path: PROJECT_DETAIL_ROUTE + '/:id',
		Component: ProjectDetailPage,
	},
	{
		path: CREATE_PROJECT_ROUTE,
		Component: ProjectCreatePage,
	},
	{
		path: CHECK_PROJECT_ROUTE + '/:id',
		Component: ProjectCheckPage,
	},
	{
		path: SETTINGS_ROUTE,
		Component: SettingsPage,
	},
];

export const adminRoutes = [
	{
		path: USERS_ROUTE,
		Component: UsersPage,
	},
	{
		path: USER_DETAIL_ROUTE + '/:id',
		Component: UserDetailPage,
	},
	{
		path: WEB_CHECKS_ROUTE,
		Component: WebChecksPage,
	},
	{
		path: WEB_CHECK_DETAIL_ROUTE + '/:id',
		Component: WebCheckDetailPage,
	},
];
